// Lifted from useFiveSegmentsTableColumns; pure so basic-output can reuse without React/Jotai.

import * as R from 'remeda'

import { type ColumnInfo, compact, fiveSegments } from '~/utils'

import {
  type FiveSegmentColumnKey as ColumnKey,
  fiveSegmentIndicators,
} from './fiveSegments'

const widthMap: Record<ColumnKey, string> = {
  questionText: '11em',
  answerNumber: 'max-content',
  answerText: 'max-content',
  ...R.mapToObj(
    ['total', ...fiveSegments, ...fiveSegmentIndicators] as const,
    (indicator) => [indicator, '7em'],
  ),
  ...R.mapToObj(['loyalPad', 'generalPad'] as const, (indicator) => [
    indicator,
    '0.5rem',
  ]),
}

export const buildFiveSegmentsTableColumns = ({
  hiddenColumnKeys,
}: {
  hiddenColumnKeys: ReadonlyArray<ColumnKey>
}): ColumnInfo<ColumnKey>[] => {
  const visibleAllOrFiveSegments = R.difference(
    R.reverse([...fiveSegments, 'total'] satisfies ColumnKey[]),
    hiddenColumnKeys,
  )
  const visibleLoyalIndicators = R.difference(
    [
      'loyalVsRecognized',
      'loyalVsEstranged',
      'loyalVsGeneral',
    ] satisfies ColumnKey[],
    hiddenColumnKeys,
  )
  const visibleGeneralIndicators = R.difference(
    ['generalVsRecognized', 'generalVsEstranged'] satisfies ColumnKey[],
    hiddenColumnKeys,
  )

  const hasLoyalPad =
    0 < visibleAllOrFiveSegments.length && 0 < visibleLoyalIndicators.length

  const hasGeneralPad =
    (0 < visibleAllOrFiveSegments.length ||
      0 < visibleLoyalIndicators.length) &&
    0 < visibleGeneralIndicators.length

  const columnKeys: ColumnKey[] = compact([
    'questionText',
    'answerNumber',
    'answerText',
    ...visibleAllOrFiveSegments,
    hasLoyalPad && 'loyalPad',
    ...visibleLoyalIndicators,
    hasGeneralPad && 'generalPad',
    ...visibleGeneralIndicators,
  ])

  return columnKeys.map((key) => ({ key, width: widthMap[key] }))
}
